import { Component } from '@angular/core';

@Component({
  selector: 'gtd-dot-separator',
  template: '<div class="c-dot-separator"></div>',
})
export class DotSeparatorComponent {}
